import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Check from '../../../assets/icons/Check'
import { NavBar } from '../../../components/NavBar/NavBar'
import { Pagination } from '../../../components/Pagination/Pagination'
import {
  Button,
  Flex,
  GridItem,
  H1WithBack,
  ItemsGrid,
  PageFooter,
  PageWrapper,
} from '../../../styling/GlobalStyles'
import { useNavigate, useParams } from 'react-router-dom'
import { AppDispatch, RootState } from 'store'
import {
  getSingleInventoryCategory,
  updateInventoryCategory,
} from 'features/inventory/invSettingsCategoriesSlice'
import { clearInventoryFieldsList, getInvSettingsFields } from 'features/inventory/invSettingsFieldsSlice'
import { getParams, handlePagination } from 'utils/helpers'
import { CancelBtn } from 'components/Button/CancelBtn'
import useQueryPagination from 'hooks/useQueryPagination'
import { NoItems } from 'components/NoItems-fallback/NoItems'
import { convertToInvCategoriesModalData } from './InventoryCategories'

export const InventorySubcategoryFields = () => {
  const dispatch = useDispatch<AppDispatch>()
  const { fields, totalPages } = useSelector((store: RootState) => store.invSettingsFields)
  const { singleInventoryCategory } = useSelector(
    (state: RootState) => state.inventoryCategories,
  )
  const [array, setArray] = useState([])
  const navigate = useNavigate()
  const { subId } = useParams()
  const [params, setParams] = useState<any>(getParams({ location }))

  const handleSubmit = async () => {
    const resp = await dispatch(updateInventoryCategory({ category: convertToInvCategoriesModalData(singleInventoryCategory), fields: array }))
    if (resp.meta.requestStatus === 'fulfilled') {
      navigate(-1)
    }
  }

  useEffect(() => {
    setArray(singleInventoryCategory?.fields?.map(f => f.field.id) || [])
  }, [singleInventoryCategory])

  useEffect(() => {
    dispatch(getSingleInventoryCategory(subId))
  }, [])

  useQueryPagination({ fetchFunctions: [getInvSettingsFields], cleanUpFunctions: [clearInventoryFieldsList], params })

  const handleAdd = (id: number) => {
    if (array.some((i) => i == id)) {
      setArray((prev) => prev.filter((i) => i !== id))
    } else {
      setArray((prev) => [...prev, id])
    }
  }

  return (
    <>
      <NavBar input placeholder='Search fields..' setParams={setParams} limit={30} />
      <PageWrapper>
        <H1WithBack arrow title='Add fields' />
        <ItemsGrid columns={3} mt='1.5rem'>
          {!fields?.length ? <NoItems title='filelds' /> :
            fields.map((item) => {
              return (
                <GridItem
                  key={item.id}
                  valid={array.some((i) => i == item.id)}
                  onClick={() => handleAdd(item.id)}
                >
                  {item.label}
                  <Check valid={array.some((i) => i == item.id)} />
                </GridItem>
              )
            })}
        </ItemsGrid>
      </PageWrapper>
      <PageFooter >
        {totalPages > 1 ? (
          <Flex width='100%' between center gap='2rem' >
            <Pagination
              setPage={(page) => handlePagination(page, setParams)}
              pageCount={Math.ceil(totalPages)}
              forcePage={(params.page ? params.page : 1) - 1}
            />
            <Flex gap='1rem'>
              <Button onClick={() => navigate(-1)}>Cancel</Button>
              <Button orange onClick={handleSubmit}>
                Save
              </Button>
            </Flex>
          </Flex>
        ) : (
          <Flex gap='1rem'>
            <CancelBtn />
            <Button orange onClick={handleSubmit}>
              Save
            </Button>
          </Flex>
        )}
      </PageFooter>
    </>
  )
}
